import NEW from './new';
import ADDITIONS from './additions';
export default NEW.concat(ADDITIONS);